import { ANALYTICS_EVENTS } from '../../events'
import createAnalyticsStatic, { EventProps } from '../createAnalyticsEvent'

/**
 * Props for Passkey Auth Submitted event.
 */
export type PasskeyAuthSubmittedProps = EventProps

/**
 * @event passkey_auth_submitted
 */
export const PasskeyAuthSubmittedAnalytics = createAnalyticsStatic<PasskeyAuthSubmittedProps>(
    ANALYTICS_EVENTS.PASSKEY.AUTH_SUBMITTED,
)

export default PasskeyAuthSubmittedAnalytics
